import { Button } from "reactstrap";
import { LogOut } from "lucide-react";
import { X } from "lucide-react";
import { LayoutDashboard, Activity, MessageSquareCode, Landmark } from "lucide-react";
import React, { memo, useCallback } from "react";
import Images from "../../Helper/ImageConstants";
import { Menu, MenuItem } from "react-pro-sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { Bed, PersonStanding } from "lucide-react";
import useLogout from "../../hooks/useLogout";

const AdminSidebar = ({ toggleSidebar, setToggleSidebar }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const logout = useLogout();
  // useLogout hard-navigates to this role's own sign-in (clean URL, no
  // redirect query) — no extra navigation here or it races the hook's.
  const handleLogoutClick = logout;

  const handlePracticesClick = useCallback(() => {
    navigate("/admin/practices");
  }, [navigate]);

  const handleDoctorsClick = useCallback(() => {
    navigate("/admin/doctors");
  }, [navigate]);

  const handleEngagementClick = useCallback(() => {
    navigate("/admin/engagement");
  }, [navigate]);

  const handleDashboardClick = useCallback(() => {
    navigate("/admin/dashboard");
  }, [navigate]);

  return (
    <div
      className={`sidebar-content shadow transition position-absolute`}
      style={{
        width: toggleSidebar ? "260px" : "0px",
        overflow: "hidden",
      }}
    >
      <div className="d-flex py-3 justify-content-center ">
        <div className="d-flex align-items-center justify-content-center mb-4">
          <img src={Images.LOGO_IMG} alt="Healink" width={180} />
        </div>
        <div>
          {window.innerWidth <= 576 && (
            <Button
              data-testid="sidebar-mobile-close"
              onClick={() => setToggleSidebar(!toggleSidebar)}
              className="border-0 cursor-pionter text-align-center bg-transparent p-3"
            >
              <X size={20} className="text-danger me-3" />
            </Button>
          )}
        </div>
      </div>
      <Menu className="Menu fw-bolder overflow-hidden px-3">
        <MenuItem
          icon={<LayoutDashboard size={18} />}
          className={`${
            pathname.includes("/admin/dashboard")
              ? "activeMenuItem"
              : "MenuItem fw-medium"
          }`}
          onClick={handleDashboardClick}
        >
          {"Dashboard"}
        </MenuItem>
        <MenuItem
          icon={<Bed size={20} />}
          className={`${
            pathname.includes("/admin/practices")
              ? "activeMenuItem"
              : "MenuItem fw-medium"
          }`}
          onClick={handlePracticesClick}
        >
          {"Practices"}
        </MenuItem>
        <MenuItem
          icon={<PersonStanding size={20} />}
          className={`${
            pathname.includes("/admin/doctors") ? "activeMenuItem" : "MenuItem fw-medium"
          }`}
          onClick={handleDoctorsClick}
        >
          {"Doctors"}
        </MenuItem>
        <MenuItem
          icon={<Activity size={18} />}
          className={`${
            pathname.includes("/admin/engagement")
              ? "activeMenuItem"
              : "MenuItem fw-medium"
          }`}
          onClick={handleEngagementClick}
        >
          {"Engagement"}
        </MenuItem>

        <MenuItem
          icon={<MessageSquareCode size={18} />}
          className={`${
            pathname.includes("/admin/system-prompts")
              ? "activeMenuItem"
              : "MenuItem fw-medium"
          }`}
          onClick={() => navigate("/admin/system-prompts")}
        >
          {"System Prompts"}
        </MenuItem>

        <MenuItem
          icon={<Landmark size={18} />}
          className={`${
            pathname.includes("/admin/financing-partners")
              ? "activeMenuItem"
              : "MenuItem fw-medium"
          }`}
          onClick={() => navigate("/admin/financing-partners")}
        >
          {"Financing Partners"}
        </MenuItem>

        <MenuItem
          className="MenuItem fw-medium position-absolute bottom-0"
          icon={<LogOut size={18} />}
          onClick={handleLogoutClick}
        >
          {"Log Out"}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default memo(AdminSidebar);
